<app-dashboard-layout [downloader]="downloader">
  <app-notification-alert [data]="notification"></app-notification-alert>

  <form class="flex flex-col mx-auto max-w-screen-md p-4 z-20 justify-center">
    <h1 class="font-medium text-center text-lg">
      Select Application Type
    </h1>

    <section *ngIf="skeletonLoader">
      <div class="border rounded-md bg-gray-300 h-16 my-8 animate-pulse"></div>
      <div class="border rounded-md mx-auto max-w-md bg-gray-300 h-8 my-8 animate-pulse"></div>
    </section>

    <section *ngIf="!skeletonLoader">
      <div class="py-8">
        <div class="bg-white border border-primary rounded-lg w-full p-2">
          <select name="applicationType" [(ngModel)]="applicationType" class="w-full p-2 focus:outline-none">
            <option disabled value="">-- Select Application Type --</option>
            <option *ngFor="let applicationType of applicationTypes" [value]="applicationType.Id">{{ applicationType.Name }}</option>
          </select>
        </div>
      </div>

      <app-button-primary class="w-full" (click)="submitApplication()" [disabled]="skeletonLoader || loading">
        Continue Application
      </app-button-primary>
    </section>
  </form>
</app-dashboard-layout>